import React, { useContext, useState } from "react";

import ReactCountryFlag from "react-country-flag";
import { useNavigate } from "react-router-dom";
import { AiOutlineLeft } from "react-icons/ai";

import { useTypedDispatch, useTypedSelector } from "../../store/typeHooks";
import { UserContext } from "../../Providers/UserContext";
import { withdraw, WithdrawResponse } from "../../API/payment";

import Header from "../../layout/Header";
import Spinner from "../../components/Spinner";
import { Flex, Input, Tool, WithdrawButton } from "../../components/Modals/styled";

import BankImg from "../../assets/image/payment/bank.png";

const Withdrawal: React.FC = () => {
  const payment_list = [
    {
      name: "Bank",
      image: BankImg,
      type: "bank",
    },
  ];
  const navigate = useNavigate();
  const dispatch = useTypedDispatch();
  const { balance } = useTypedSelector((state) => state.account);
  const { id } = useTypedSelector((state) => state.auth);
  const { currentCountry, countryCode } = useContext(UserContext);
  const [toolIndex, setToolIndex] = useState(payment_list[0]);
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [isDiable, setDisable] = useState(true);

  const handleWithdraw = async () => {
    setLoading(true);
    const data = {
      amount: amount,
      customer_name: id,
    };

    await dispatch(withdraw(data))
      .then((result) => {
        setLoading(false);
        window.open((result.payload as WithdrawResponse).url, "_self");
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const handleAmount = (value: string) => {
    setAmount(value);
    if (value !== "") {
      if (Number(value) <= balance) {
        setDisable(false);
      } else {
        setDisable(true);
      }
    } else {
      setDisable(true);
    }
  };

  return (
    <React.Fragment>
      <Header />
      <Flex direction="column" style={{ padding: "15px", textAlign: "left" }}>
        <Flex direction="row" alignItems="center" style={{ marginBottom: "8px" }}>
          <Flex
            direction="row"
            alignItems="center"
            style={{ gap: "6px", margin: "5px 0", cursor: "pointer", flex: 1 }}
            onClick={() => navigate("/profile")}
          >
            <AiOutlineLeft style={{ width: "13px", height: "13px" }} />
            <div style={{ fontSize: "13px" }}>Profile</div>
          </Flex>
          <div style={{ fontSize: "14px", fontWeight: 600 }}>Withdrawal</div>
          <div style={{ flex: 1 }} />
        </Flex>
        <div style={{ backgroundColor: "white", padding: "20px", borderRadius: "16px" }}>
          <div style={{ padding: "15px", boxShadow: "0 4px 28px #d8e0ee", borderRadius: "10px" }}>
            <div style={{ fontSize: "11px", color: "#94a6cd" }}>Main wallet</div>
            <div style={{ fontSize: "15px", color: "#090f1e", fontWeight: 700 }}>
              {balance.toLocaleString("en-US", {
                style: "currency",
                currency: "ZAR",
              })}
            </div>
          </div>
          <div style={{ margin: "13px 0 20px" }}></div>

          <Flex alignItems="center" style={{ gap: "10px", marginBottom: "15px" }}>
            {/* <div style={{ width: "18px", height: "18px", backgroundColor: "#6a7690", borderRadius: "50%" }} /> */}
            <ReactCountryFlag
              countryCode={countryCode}
              svg
              cdnUrl="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/"
              title={countryCode}
              style={{ height: "1.5em", width: "1.5em", borderRadius: "50%" }}
            />
            <Flex direction="column" style={{ textAlign: "left", gap: "5px" }}>
              <div style={{ fontSize: "11px", fontWeight: 400, color: "#6a769065" }}>Payment methods for the region</div>
              <div style={{ fontSize: "11px", fontWeight: 600, color: "#6a7690" }}>{currentCountry}</div>
            </Flex>
          </Flex>
          <div style={{ fontSize: "9px", color: "#090f1e", opacity: 0.3 }}>All methods</div>
          <div style={{ display: "grid", gridTemplateColumns: "auto auto auto", gap: "10px", paddingTop: "10px" }}>
            {payment_list.map((value) => (
              <Tool selected={toolIndex.type === value.type} onClick={() => setToolIndex(value)}>
                <img src={value.image} alt={value.name} />
              </Tool>
            ))}
          </div>
          <Flex direction="column" style={{ gap: "15px" }}>
            <div style={{ color: "#070c19", fontSize: "12px", textAlign: "left" }}>
              One withdrawal limits: <br /> 2 000 ₽ - 50 000 ₽
            </div>
            <div>
              <Flex direction="row" alignItems="center" style={{ backgroundColor: "#EDF0F7", padding: "0 15px", borderRadius: "10px" }}>
                <Flex style={{ width: "68px" }}>
                  <svg
                    width="100"
                    height="25"
                    viewBox="0 0 100 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    id="card_rub"
                    className="PaymentIcon_color_CcKvf PaymentIcon_icon_tinGf PaymentIcon_autoWidth_U7810"
                    style={{ height: "17px" }}
                  >
                    <g className="card_svg__mono" fillRule="evenodd">
                      <path
                        fill="#fff"
                        d="M40.773 7.579a9.876 9.876 0 00-1.526-.544 8.669 8.669 0 00-2.502-.288c-.563.019-1.113.106-1.62.375-.332.175-.607.407-.75.763-.176.426-.088.801.2 1.145.262.313.6.544.95.738.388.219.778.428 1.17.638.258.138.517.277.776.42.725.4 1.42.85 2.001 1.45.626.639 1.045 1.383 1.195 2.271.075.457.081.913.031 1.376a5.433 5.433 0 01-.65 2.127c-.557.994-1.364 1.72-2.352 2.264-.838.463-1.74.744-2.684.92-.857.156-1.72.219-2.59.194-1.388-.044-2.751-.232-4.078-.657a13.174 13.174 0 01-.525-.188l-.219-.081c.281-1.301.557-2.596.832-3.897.05.019.088.037.125.056.657.313 1.32.595 2.027.776.581.15 1.17.244 1.77.275.463.025.92.038 1.376-.025.607-.081 1.182-.238 1.664-.638.469-.381.644-.976.456-1.507a1.515 1.515 0 00-.419-.607 4.864 4.864 0 00-1.094-.75c-.24-.129-.481-.253-.723-.377-.302-.156-.605-.311-.904-.474-.781-.426-1.507-.939-2.108-1.608-.531-.594-.907-1.27-1.044-2.058-.125-.707-.063-1.407.119-2.095.331-1.22 1.05-2.177 2.051-2.921.92-.682 1.958-1.101 3.072-1.352a11.435 11.435 0 013.027-.243c1.251.056 2.465.319 3.64.738.082.03.094.056.082.143a647.598 647.598 0 00-.763 3.566c.006.012 0 .037-.013.075zm16.238 13.567h-4.128c-.088 0-.125-.019-.144-.112-.094-.458-.19-.916-.287-1.373l-.226-1.08c-.012-.068-.044-.093-.119-.093h-5.73c-.068 0-.1.025-.118.087-.294.825-.594 1.65-.894 2.474v.003c-.026.07-.057.094-.132.094h-4.716c.018-.044.031-.075.043-.112l3.419-8.163c1.14-2.721 2.28-5.442 3.418-8.163.313-.75.864-1.201 1.67-1.332.107-.02.22-.025.326-.025h3.796c.088 0 .113.03.132.112l1.2 5.761c.182.861.361 1.724.54 2.588l.002.005.54 2.592.631 3.015.002.007c.21 1.007.422 2.014.631 3.02.029.133.055.263.082.394v.002l.062.3zM50.063 8.192l-.001-.006h-.031c-.807 2.22-1.608 4.434-2.415 6.668 1.282-.007 2.552-.007 3.835-.007-.463-2.23-.925-4.442-1.388-6.654zM.08 3.645l-.046.218c.031.007.056.013.075.032.259.07.52.138.78.206.483.126.968.252 1.447.394.788.232 1.545.532 2.27.913.482.257.801.632.945 1.164l.272 1.034v.001l.272 1.035 2.909 11.26c.053.209.108.417.162.625.055.208.11.416.163.625a.502.502 0 00.094.007h4.679c.075.006.106-.025.131-.094l3.679-8.778.003-.007.005-.013 3.688-8.798.014-.04c.006-.02.012-.04.023-.066h-.131c-.76-.003-1.52-.003-2.28-.003-.76 0-1.52 0-2.28-.003-.1 0-.144.031-.181.125l-1.278 3.235-.002.005v.002c-1.083 2.736-2.165 5.476-3.25 8.216-.069.169-.138.338-.213.532l-.025-.125-.288-1.531v-.002c-.12-.631-.239-1.263-.356-1.895-.11-.588-.22-1.176-.332-1.764-.11-.588-.222-1.176-.331-1.764l-.205-1.088c-.136-.726-.272-1.451-.414-2.177-.22-1.082-1.07-1.77-2.177-1.77H.14l-.06.288zm19.858 17.048l-.094.447c.003 0 .005.002.008.003.014.005.025.008.036.003h4.478c.05 0 .07-.019.082-.069l.072-.334a3881.074 3881.074 0 011.829-8.55v-.004c.51-2.367 1.017-4.739 1.522-7.108.09-.416.178-.833.267-1.249.038-.156.069-.313.1-.481h-.075l-1.476.001c-.984.001-1.968.003-2.953-.001-.083 0-.093.045-.104.097l-.002.009c-.106.475-.206.95-.306 1.426-.37 1.714-.738 3.434-1.107 5.154-.185.857-.368 1.716-.55 2.574l-.551 2.574c-.182.844-.362 1.687-.541 2.53a1783.927 1783.927 0 01-.635 2.978z"
                        clipRule="evenodd"
                      ></path>
                      <path fill="#C3DDF7" d="M78.175 4.206H87.2V20.42h-9.024V4.206z"></path>
                      <path
                        fill="#fff"
                        d="M78.748 12.313c0-3.294 1.547-6.216 3.925-8.107A10.25 10.25 0 0076.313 2C70.613 2 66 6.612 66 12.313a10.306 10.306 0 0010.313 10.313c2.406 0 4.612-.83 6.36-2.206a10.298 10.298 0 01-3.925-8.107zm20.626 0a10.306 10.306 0 01-10.313 10.313 10.25 10.25 0 01-6.36-2.206 10.254 10.254 0 003.925-8.107c0-3.294-1.547-6.216-3.925-8.107A10.25 10.25 0 0189.061 2c5.701 0 10.313 4.64 10.313 10.313z"
                      ></path>
                    </g>
                    <g className="card_svg__color" fillRule="evenodd">
                      <path
                        fill="url(#card_svg__a)"
                        d="M40.773 7.579a9.876 9.876 0 00-1.526-.544 8.669 8.669 0 00-2.502-.288c-.563.019-1.113.106-1.62.375-.332.175-.607.407-.75.763-.176.426-.088.801.2 1.145.262.313.6.544.95.738.388.219.778.428 1.17.638.258.138.517.277.776.42.725.4 1.42.85 2.001 1.45.626.639 1.045 1.383 1.195 2.271.075.457.081.913.031 1.376a5.433 5.433 0 01-.65 2.127c-.557.994-1.364 1.72-2.352 2.264-.838.463-1.74.744-2.684.92-.857.156-1.72.219-2.59.194-1.388-.044-2.751-.232-4.078-.657a13.174 13.174 0 01-.525-.188l-.219-.081c.281-1.301.557-2.596.832-3.897.05.019.088.037.125.056.657.313 1.32.595 2.027.776.581.15 1.17.244 1.77.275.463.025.92.038 1.376-.025.607-.081 1.182-.238 1.664-.638.469-.381.644-.976.456-1.507a1.515 1.515 0 00-.419-.607 4.864 4.864 0 00-1.094-.75c-.24-.129-.481-.253-.723-.377-.302-.156-.605-.311-.904-.474-.781-.426-1.507-.939-2.108-1.608-.531-.594-.907-1.27-1.044-2.058-.125-.707-.063-1.407.119-2.095.331-1.22 1.05-2.177 2.051-2.921.92-.682 1.958-1.101 3.072-1.352a11.435 11.435 0 013.027-.243c1.251.056 2.465.319 3.64.738.082.03.094.056.082.143a647.598 647.598 0 00-.763 3.566c.006.012 0 .037-.013.075zm16.238 13.567h-4.128c-.088 0-.125-.019-.144-.112-.094-.458-.19-.916-.287-1.373l-.226-1.08c-.012-.068-.044-.093-.119-.093h-5.73c-.068 0-.1.025-.118.087-.294.825-.594 1.65-.894 2.474v.003c-.026.07-.057.094-.132.094h-4.716c.018-.044.031-.075.043-.112l3.419-8.163c1.14-2.721 2.28-5.442 3.418-8.163.313-.75.864-1.201 1.67-1.332.107-.02.22-.025.326-.025h3.796c.088 0 .113.03.132.112l1.2 5.761c.182.861.361 1.724.54 2.588l.002.005.54 2.592.631 3.015.002.007c.21 1.007.422 2.014.631 3.02.029.133.055.263.082.394v.002l.062.3zM50.063 8.192l-.001-.006h-.031c-.807 2.22-1.608 4.434-2.415 6.668 1.282-.007 2.552-.007 3.835-.007-.463-2.23-.925-4.442-1.388-6.654zM.08 3.645l-.046.218c.031.007.056.013.075.032.259.07.52.138.78.206.483.126.968.252 1.447.394.788.232 1.545.532 2.27.913.482.257.801.632.945 1.164l.272 1.034v.001l.272 1.035 2.909 11.26c.053.209.108.417.162.625.055.208.11.416.163.625a.502.502 0 00.094.007h4.679c.075.006.106-.025.131-.094l3.679-8.778.003-.007.005-.013 3.688-8.798.014-.04c.006-.02.012-.04.023-.066h-.131c-.76-.003-1.52-.003-2.28-.003-.76 0-1.52 0-2.28-.003-.1 0-.144.031-.181.125l-1.278 3.235-.002.005v.002c-1.083 2.736-2.165 5.476-3.25 8.216-.069.169-.138.338-.213.532l-.025-.125-.288-1.531v-.002c-.12-.631-.239-1.263-.356-1.895-.11-.588-.22-1.176-.332-1.764-.11-.588-.222-1.176-.331-1.764l-.205-1.088c-.136-.726-.272-1.451-.414-2.177-.22-1.082-1.07-1.77-2.177-1.77H.14l-.06.288zm19.858 17.048l-.094.447c.003 0 .005.002.008.003.014.005.025.008.036.003h4.478c.05 0 .07-.019.082-.069l.072-.334a3881.074 3881.074 0 011.829-8.55v-.004c.51-2.367 1.017-4.739 1.522-7.108.09-.416.178-.833.267-1.249.038-.156.069-.313.1-.481h-.075l-1.476.001c-.984.001-1.968.003-2.953-.001-.083 0-.093.045-.104.097l-.002.009c-.106.475-.206.95-.306 1.426-.37 1.714-.738 3.434-1.107 5.154-.185.857-.368 1.716-.55 2.574l-.551 2.574c-.182.844-.362 1.687-.541 2.53a1783.927 1783.927 0 01-.635 2.978z"
                        clipRule="evenodd"
                      ></path>
                      <path fill="#FF5F00" d="M78.175 4.206H87.2V20.42h-9.024V4.206z"></path>
                      <path
                        fill="#EB001B"
                        d="M78.748 12.313c0-3.294 1.547-6.216 3.925-8.107A10.25 10.25 0 0076.313 2C70.613 2 66 6.612 66 12.313a10.306 10.306 0 0010.313 10.313c2.406 0 4.612-.83 6.36-2.206a10.298 10.298 0 01-3.925-8.107z"
                      ></path>
                      <path
                        fill="#F79E1B"
                        d="M99.374 12.313a10.306 10.306 0 01-10.313 10.313 10.25 10.25 0 01-6.36-2.206 10.254 10.254 0 003.925-8.107c0-3.294-1.547-6.216-3.925-8.107A10.25 10.25 0 0189.061 2c5.701 0 10.313 4.64 10.313 10.313z"
                      ></path>
                      <defs>
                        <linearGradient id="card_svg__a" x1="-.064" x2="56.736" y1="72.468" y2="72.468" gradientUnits="userSpaceOnUse">
                          <stop stopColor="#222459"></stop>
                          <stop offset="1" stopColor="#2548A1"></stop>
                        </linearGradient>
                      </defs>
                    </g>
                  </svg>
                  <div style={{ backgroundColor: "#6a769033", width: "1px", marginLeft: "12px" }} />
                </Flex>
                <Input
                  type="number"
                  placeholder="Amount"
                  onChange={(e) => handleAmount(e.target.value)}
                  value={amount}
                  style={{ width: "100%", height: "43px", padding: "0 15px 0 10px" }}
                />
              </Flex>
              {Number(amount) > balance && (
                <p style={{ color: "red", margin: 0, textAlign: "left", marginLeft: "20px" }}>Not enough amount</p>
              )}
            </div>
            {/* <Flex direction="row" alignItems="center" style={{ backgroundColor: "#EDF0F7", padding: "0 15px", borderRadius: "10px" }}>
              <Input type="number" placeholder="Bank card number" style={{ width: "100%", height: "43px" }} />
              <div style={{ backgroundColor: "#888787", borderRadius: "50%", width: "5px", height: "5px" }} />
            </Flex> */}
            {loading ? (
              <WithdrawButton>
                <Spinner />
              </WithdrawButton>
            ) : (
              <WithdrawButton onClick={handleWithdraw} disabled={isDiable}>
                Withdraw
              </WithdrawButton>
            )}
          </Flex>
        </div>
      </Flex>
    </React.Fragment>
  );
};

export default Withdrawal;
